var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateTours(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 66,
    viewBox: "0 0 65 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8 29.74L14.8 31.6745L14.2 32.2855C14.1 32.3873 14 32.3873 13.8 32.3873H13.7C13.5 32.3873 13.4 32.2855 13.3 32.0818L11.2 28.2127C11.3 28.2127 11.3 28.1109 11.3 28.1109L15.2 24.6491L15.8 29.74Z",
    fill: "url(#paint0_linear_99_105)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 19.66L6.8 23.5291C6.7 23.6309 6.7 23.6309 6.6 23.7327L2.9 21.5945C2.8 21.4927 2.7 21.3909 2.6 21.1873C2.6 20.9836 2.6 20.8818 2.7 20.78L4.2 19.2527C4.3 19.1509 4.5 19.0491 4.6 19.1509L10.1 19.66Z",
    fill: "url(#paint1_linear_99_105)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 14.6709L0.2 7.23818C0.1 7.13636 0 7.03454 0 6.83091C0 6.62727 2.23517e-08 6.52545 0.1 6.42364L2.3 4.18363C2.4 4.08182 2.6 3.98 2.8 4.08182L20.3 7.54364L14.2 14.6709Z",
    fill: "url(#paint2_linear_99_105)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1 20.2709C27.9 20.3727 24.8 21.4927 22.3 23.1218L20.8 20.1691L27.9 13.9582L29.1 20.2709Z",
    fill: "url(#paint3_linear_99_105)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34 4.18364C33.9 6.01636 33 8.15454 31.7 9.27454L10.8 27.5C10.4 27.9073 9.9 28.0091 9.3 28.0091C8.7 28.0091 8.1 27.8055 7.7 27.2964C6.9 26.4818 6.8 25.0564 7.6 24.14L25.5 2.86C26.6 1.53636 28.8 0.518181 30.6 0.518181C31.6 0.518181 32.5 0.823635 33.1 1.43454C33.7 2.04545 34 3.06364 34 4.18364Z",
    fill: "url(#paint4_linear_99_105)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8 29.74L14.8 31.6745C15.1 31.0636 15.4 30.3509 15.8 29.74Z",
    fill: "url(#paint5_linear_99_105)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8 41.4491C43.8 43.5873 43.6 45.7255 43.3 47.66H46.3V46.9473C46.3 45.5218 47.4 44.4018 48.8 44.4018H53C53.2 43.3836 53.2 42.4673 53.3 41.4491H43.8ZM34 41.4491V51.1218C35.6 51.1218 37.1 51.2236 38.6 51.4273V50.3073C38.6 48.8818 39.7 47.7618 41.1 47.7618H42.2C42.5 45.7255 42.7 43.6891 42.7 41.5509H34V41.4491ZM37.2 60.6927C37.4 60.6927 37.5 60.5909 37.7 60.5909C38 60.4891 38.3 60.4891 38.6 60.3873V59.3691C38.1 59.8782 37.6 60.3873 37.2 60.6927ZM34 52.14V60.9982C35.6 60.7945 37.2 59.6745 38.6 57.6382V52.4455C37.1 52.2418 35.5 52.14 34 52.14ZM41.4 30.5545C39.1 31.0636 36.6 31.2673 34 31.3691V40.4309H42.8C42.7 36.9691 42.2 33.5073 41.4 30.5545ZM23.2 41.4491H13.7C13.8 46.1327 15.5 50.7145 18.6 54.1764C20.4 53.26 22.4 52.5473 24.7 52.0382C23.7 48.8818 23.2 45.2164 23.2 41.4491ZM34 20.8818V30.3509C36.5 30.3509 38.9 30.0455 41.1 29.6382C39.5 24.4455 36.8 21.1873 34 20.8818ZM26 52.8527C27.7 57.74 30.2 60.6927 33 61.1V52.2418C30.5 52.14 28.2 52.4455 26 52.8527ZM24.2 41.4491C24.3 45.1145 24.8 48.6782 25.7 51.8345C28 51.3255 30.5 51.1218 33 51.1218V41.4491H24.2ZM25.5 30.5545C24.7 33.5073 24.2 36.9691 24.1 40.4309H33V31.3691C30.4 31.2673 27.9 31.0636 25.5 30.5545ZM25.8 29.5364C28 30.0455 30.5 30.2491 32.9 30.2491V20.8818C30.1 21.1873 27.4 24.4455 25.8 29.5364ZM37.2 21.1873C39.2 22.7145 40.9 25.5655 42.1 29.3327C44.3 28.8236 46.3 28.1109 48 27.2964C45 24.0382 41.2 22.0018 37.2 21.1873ZM19 27.2964C20.7 28.2127 22.7 28.8236 24.9 29.3327C26.1 25.5655 27.8 22.7145 29.8 21.1873C25.6 22.0018 22.1 23.9364 19 27.2964ZM18.3 28.0091C15.4 31.4709 13.8 35.8491 13.7 40.4309H23.2C23.2 36.8673 23.7 33.4055 24.6 30.3509C22.2 29.74 20.1 29.0273 18.3 28.0091ZM25 53.0564C22.9 53.5655 21 54.1764 19.3 54.9909C22.4 58.1473 26 59.98 29.7 60.6927C27.8 59.2673 26.2 56.62 25 53.0564ZM48.6 28.0091C46.8 28.9255 44.7 29.74 42.3 30.3509C43.2 33.4055 43.6 36.8673 43.7 40.4309H53.2C53.1 35.9509 51.5 31.5727 48.6 28.0091Z",
    fill: "url(#paint6_linear_99_105)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7 57.8418C49.7 58.1473 49.9 58.3509 50.2 58.3509H53.4C53.7 58.3509 53.9 58.1473 53.9 57.8418V57.2309V56.62C53.9 56.3145 53.7 56.1109 53.4 56.1109H50.2C49.9 56.1109 49.7 56.3145 49.7 56.62V57.2309V57.8418Z",
    fill: "url(#paint7_linear_99_105)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9 57.74C54.9 58.6564 54.2 59.3691 53.4 59.3691H50.2C49.4 59.3691 48.7 58.6564 48.7 57.8418V57.74H42.8C41.7 57.74 40.6 57.3327 39.8 56.4164C39.7 56.3145 39.7 56.2127 39.6 56.1109V64.0527C39.6 64.8673 40.3 65.58 41.1 65.58H62.5C63.3 65.58 64 64.8673 64 64.0527V56.1109C63.2 57.0273 62.1 57.6382 60.8 57.6382H54.9V57.74Z",
    fill: "url(#paint8_linear_99_105)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 48.78H56.4V46.9473C56.4 46.1327 55.7 45.42 54.9 45.42H48.8C48 45.42 47.3 46.1327 47.3 46.9473V48.78H41.2C40.4 48.78 39.7 49.4927 39.7 50.3073V53.4636C39.7 54.38 40 55.1945 40.6 55.8055C41.2 56.4164 42 56.8236 42.9 56.8236H48.8V56.7218C48.8 55.9073 49.5 55.1945 50.3 55.1945H53.5C54.3 55.1945 55 55.9073 55 56.7218V56.8236H60.9C62.7 56.8236 64.1 55.3982 64.1 53.5655V52.8527V50.4091C64 49.4927 63.3 48.78 62.5 48.78ZM48.2 46.9473C48.2 46.6418 48.4 46.4382 48.7 46.4382H54.8C55.1 46.4382 55.3 46.6418 55.3 46.9473V48.78H48.2V46.9473Z",
    fill: "url(#paint9_linear_99_105)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_99_105",
    x1: 13.5,
    y1: 24.6491,
    x2: 13.5,
    y2: 32.3873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_99_105",
    x1: 6.35,
    y1: 19.1087,
    x2: 6.35,
    y2: 23.7327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_99_105",
    x1: 10.15,
    y1: 4.03964,
    x2: 10.15,
    y2: 14.6709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_99_105",
    x1: 24.95,
    y1: 13.9582,
    x2: 24.95,
    y2: 23.1218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_99_105",
    x1: 20.5238,
    y1: 0.518181,
    x2: 20.5238,
    y2: 28.0091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_99_105",
    x1: 15.3,
    y1: 29.74,
    x2: 15.3,
    y2: 31.6745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_99_105",
    x1: 33.5,
    y1: 20.8818,
    x2: 33.5,
    y2: 61.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_99_105",
    x1: 51.8,
    y1: 56.1109,
    x2: 51.8,
    y2: 58.3509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_99_105",
    x1: 51.8,
    y1: 56.1109,
    x2: 51.8,
    y2: 65.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_99_105",
    x1: 51.9,
    y1: 45.42,
    x2: 51.9,
    y2: 56.8236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateTours);
export default __webpack_public_path__ + "static/media/Corporate Tours.a1365b8dc78260a374537032a3c9ab38.svg";
export { ForwardRef as ReactComponent };